import React from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import { classNames } from '@sie/web-common-react-components';

var GridList = function GridList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      itemSize = _ref.itemSize,
      qa = _ref.qa;

  var _GridList$getClassNam = GridList.getClassName({
    className: className
  }),
      root = _GridList$getClassNam.root;

  var itemSizeClass = {
    xs: classNames('psw-l-w-1/2@mobile-s', 'psw-l-w-1/2@mobile-l', 'psw-l-w-1/6@tablet-l', 'psw-l-w-1/4@tablet-s', 'psw-l-w-1/6@laptop', 'psw-l-w-1/8@desktop', 'psw-l-w-1/8@max'),
    s: '',
    m: classNames('psw-l-w-1/2@mobile-s', 'psw-l-w-1/2@mobile-l', 'psw-l-w-1/3@tablet-s', 'psw-l-w-1/3@tablet-l', 'psw-l-w-1/4@laptop', 'psw-l-w-1/4@desktop', 'psw-l-w-1/4@max')
  };
  return /*#__PURE__*/React.createElement("ul", {
    "data-qa": qa,
    className: root
  }, React.Children.map(children, function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: itemSizeClass[itemSize]
    }, item);
  }));
};

var cx = classNamesFor(GridList);

GridList.getClassName = function (_ref2) {
  var className = _ref2.className;
  return {
    root: cx(className, 'psw-grid-list', 'psw-l-grid')
  };
};

GridList.defaultProps = {
  qa: '',
  className: '',
  itemSize: 's',
  children: []
};
GridList.propTypes = {
  qa: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.any),
  itemSize: PropTypes.oneOf(['xs', 's', 'm'])
};
export default GridList;